import React from 'react';
import {
  Wrap,
  Product,
  Typography,
  ErrorDisplay,
  SkeletonLoader,
  LocationDropdown,
  NothingToDisplay,
} from '../../components/index';
import { FreeProductsReducer } from '../../interfaces';
import * as _ from 'lodash';
import { Row, Col } from 'react-styled-flexboxgrid';
import {
  useResponsivity,
  renderCdnUrl,
  scrollToTop,
} from '../../helpers/helpers';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/index';
import { useNavigate } from 'react-router-dom';
import store from 'store2';
import Styled from './FreeProducts.style';
export interface FreeProductsProps {
  page: FreeProductsReducer;
  getFreeProducts: Function;
  addToOrder: Function;
  removeFromOrder: Function;
  getAddresses: Function;
  listLocation: any;
  user: any;
  getPropertyDetails: Function;
  setMeta: Function;
}
const FreeProducts: React.FC<FreeProductsProps> = (props) => {
  const {
    page,
    getFreeProducts,
    addToOrder,
    removeFromOrder,
    getAddresses,
    listLocation,
    getPropertyDetails,
    user,
    setMeta,
  } = props;
  const navigate = useNavigate();
  const isMobile = useResponsivity();
  const [t] = useTranslation('common');
  const dataLocation = _.get(listLocation, 'data.data');
  const dataLength = _.get(dataLocation, 'length');
  const loadingLocation = _.get(listLocation, 'status.loading');
  const initialPropertyId = Number(store.get('property')) || 0;
  const [propertyId, setPropertyId] = React.useState<number>(initialPropertyId);
  const findLocation = _.find(dataLocation, function (o) {
    return o.id === propertyId;
  });
  const postcode = findLocation && findLocation.postcode;
  const wholesalerSlug = _.get(user, 'data.data.wholesaler_slug');
  const { error, loading, done } = _.get(page, 'products.status');
  const renderMapOptions =
    dataLocation &&
    dataLocation.map((el) => ({ value: el.id, label: el.property_name }));
  React.useEffect(() => {
    if (propertyId) {
      getPropertyDetails(propertyId);
    }
  }, [propertyId, getPropertyDetails]);
  React.useEffect(() => {
    getFreeProducts(wholesalerSlug);
    getAddresses(`${postcode}`);
  }, [postcode, getAddresses, wholesalerSlug]);
  const { groups } = page.products;
  const { basket } = props.page;
  const singleProduct = (id, groupIndex) => {
    const { data, groups } = props.page.products;
    const elementProps = _.get(data, `entities.products[${id}]`);
    if (elementProps) {
      const count = _.get(basket, `[${id}].total`, 0);
      const { limit, limitRule } = groups[groupIndex];
      const inGroup = groups[groupIndex].products;
      const basketIds = Object.keys(basket);
      const productInBasket = _.reduce(
        inGroup,
        (total, id) => {
          if (_.includes(basketIds, id.toString())) {
            return total + 1;
          }
          return total;
        },
        0,
      );
      const itemsInBasket = _.reduce(
        inGroup,
        (total, id) => {
          if (_.includes(basketIds, id.toString())) {
            const countItem = _.get(basket, `[${id}].total`, 0);
            return total + countItem;
          }
          return total;
        },
        0,
      );
      const getMax =
        limit < inGroup.length
          ? productInBasket === limit
          : productInBasket > limit;
      const maxItemsInGroup = limit === 0 ? false : getMax;
      const maxInGroup = !(limit > itemsInBasket);
      const inBasket = _.includes(basketIds, id.toString());
      const hasImage = _.get(elementProps, 'images.path');
      const image = hasImage
        ? `https://cdn.savewatersavemoney.co.uk/cache/product_page${hasImage}`
        : renderCdnUrl('files/gwf/no-image.png');
      return (
        <Product
          description={
            elementProps.descriptionTranslationKey
              ? t(elementProps.descriptionTranslationKey)
              : elementProps.freePackDescription
          }
          maxQuantity={elementProps.maxperhousehold}
          maxInGroup={
            limitRule === 'mix-and-match'
              ? maxInGroup
              : maxItemsInGroup && !inBasket
          }
          key={elementProps.id}
          image={image}
          addToOrder={addToOrder}
          removeFromOrder={removeFromOrder}
          title={
            elementProps.titleTranslationKey
              ? t(elementProps.titleTranslationKey)
              : elementProps.title
          }
          id={elementProps.id}
          count={count}
          stockCheck={elementProps.state}
          limitedOffer={elementProps.limitedOffer}
        />
      );
    }
    return null;
  };
  const renderProducts = (groups) => {
    if (groups.length > 0) {
      return _.map(groups, (group, groupIndex) => {
        const elements = _.map(group.products, (id) =>
          singleProduct(id, groupIndex),
        );
        return (
          <Row key={groupIndex}>
            <Col xs={12} sm={12} md={4}>
              <Typography
                size="3"
                style={{ fontSize: !isMobile ? '22px' : '20px' }}
                text={group.name}
              />
            </Col>
            <Row>{elements}</Row>
          </Row>
        );
      });
    }
  };

  if (error) {
    return (
      <Wrap>
        {' '}
        <ErrorDisplay />{' '}
      </Wrap>
    );
  }
  if (loading && wholesalerSlug && loadingLocation && !done) {
    return (
      <Wrap>
        {' '}
        <SkeletonLoader />{' '}
      </Wrap>
    );
  }
  const pageTitle = t('portal.free_products.page_title');
  const pageDisclaimer = t('portal.free_products.page_disclaimer');

  const renderContent = () => {
    if (groups.length > 1) {
      return (
        <Row>
          <Col md={12} sm={12} xs={12}>
            {renderProducts(groups)}
          </Col>
          <Col md={12} sm={12} xs={12}>
            {' '}
            <div
              style={{
                display: 'flex',
                flexDirection: !isMobile ? 'row' : 'column',
              }}
            >
              {' '}
              <Typography
                size="p"
                text={pageDisclaimer}
                style={{
                  fontSize: '12px',
                  marginBottom: '16px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              />{' '}
              <Button
                onClick={() => {
                  scrollToTop();
                  navigate('/free-products/checkout');
                }}
                style={{ height: '50px' }}
              >
                {' '}
                {t('portal.free_products.page_checkout')}{' '}
              </Button>{' '}
            </div>{' '}
          </Col>
        </Row>
      );
    } else {
      return (
        <Col md={12} xs={12} sm={12}>
          <NothingToDisplay
            title="There are no products available"
            subtitle="Please come back later to check if something has changed"
          />
        </Col>
      );
    }
  };
  return (
    <Wrap>
      <Row>
        <Col md={8} xs={12} sm={12}>
          <Typography
            weight={700}
            size="1"
            text={pageTitle}
            style={{
              marginBottom: '16px',
              fontSize: !isMobile ? '40px' : '28px',
              color: '#0b2641',
            }}
          />
        </Col>
        {dataLength <= 1 ? null : (
          <Col md={4} xs={12} sm={12}>
            <Styled.DropdownWrap>
              <LocationDropdown
                value={String(propertyId)}
                onChange={(e) => {
                  const id = Number(e.target.value);
                  setPropertyId(id);
                  store('property', id);
                  setMeta(id);
                }}
                options={renderMapOptions}
              />
            </Styled.DropdownWrap>
          </Col>
        )}
        {renderContent()}
      </Row>
    </Wrap>
  );
};
export default FreeProducts;
